import { selectSelectedRole } from "@/store/userSlice";
import { CheckVerified01, Grid01, Settings03, Sliders01, Users01 } from "@untitledui/icons";
import React from "react";
import { useSelector } from "react-redux";

type ActiveTab =
  | "daraja"
  | "matrix"
  | "widget"
  | "common"
  | "user";

type Props = {
  drawerOpen: boolean;
  active: ActiveTab;
  setActive: (val: ActiveTab) => void;
};

const SideNav: React.FC<Props> = ({ drawerOpen, active, setActive }) => {
  const selectedRole = useSelector(selectSelectedRole);
const isOperatorView = selectedRole === "Operator";
  return (
    <aside
      className={`fixed left-0 top-14 h-[calc(100vh-56px)] border-r z-[900] transition-all duration-500 bg-white border-gray-200 ${
        drawerOpen ? "w-[260px]" : "w-[64px]"
      }`}
    >
      <nav className="mt-2 px-2 space-y-1">
       <div
  onClick={() => setActive("daraja")}
  className={`flex items-center cursor-pointer rounded-md text-sm font-medium transition-all ${
    drawerOpen ? "gap-3 px-3 py-2" : "justify-center h-10"
  } ${
    active === "daraja"
      ? "bg-[#fff4ec] text-orange-600"
      : "text-gray-700 hover:bg-gray-100"
  }`}
>
  <Users01 className="h-4 w-4" />
  {drawerOpen && <span>Daraja Onboarding</span>}
</div>

       {!isOperatorView && (
  <>
    <div
      onClick={() => setActive("matrix")}
      className={`flex items-center cursor-pointer rounded-md text-sm font-medium transition-all ${
        drawerOpen ? "gap-3 px-3 py-2" : "justify-center h-10"
      } ${
        active === "matrix"
          ? "bg-[#fff4ec] text-orange-600"
          : "text-gray-700 hover:bg-gray-100"
      }`}
    >
      <Grid01 className="h-4 w-4" />
      {drawerOpen && <span>Access Matrix</span>}
    </div>

    <div
      onClick={() => setActive("widget")}
      className={`flex items-center cursor-pointer rounded-md text-sm font-medium transition-all ${
        drawerOpen ? "gap-3 px-3 py-2" : "justify-center h-10"
      } ${
        active === "widget"
          ? "bg-[#fff4ec] text-orange-600"
          : "text-gray-700 hover:bg-gray-100"
      }`}
    >
      <Sliders01 className="h-4 w-4" />
      {drawerOpen && <span>Widget Configuration</span>}
    </div>

    <div
      onClick={() => setActive("common")}
      className={`flex items-center cursor-pointer rounded-md text-sm font-medium transition-all ${
        drawerOpen ? "gap-3 px-3 py-2" : "justify-center h-10"
      } ${
        active === "common"
          ? "bg-[#fff4ec] text-orange-600"
          : "text-gray-700 hover:bg-gray-100"
      }`}
    >
      <Settings03 className="h-4 w-4" />
      {drawerOpen && <span>Common Configuration</span>}
    </div>

    <div
      onClick={() => setActive("user")}
      className={`flex items-center cursor-pointer rounded-md text-sm font-medium transition-all ${
        drawerOpen ? "gap-3 px-3 py-2" : "justify-center h-10"
      } ${
        active === "user"
          ? "bg-[#fff4ec] text-orange-600"
          : "text-gray-700 hover:bg-gray-100"
      }`}
    >
      <CheckVerified01 className="h-4 w-4" />
      {drawerOpen && <span>User Eligibility</span>}
    </div>
  </>
)}
      </nav>
    </aside>
  );
};

export default SideNav;
